import appInfo from '@polleverywhere/slideware-bindings/lib/app_info'
import { cutlassEvent } from '@polleverywhere/cutlass'

export function installParticipateApp (context = 'unknown') {
  switch (appInfo.operatingSystem) {
    case 'mac':
      window.open('https://polleverywhere-app.s3.amazonaws.com/mac-participant-beta-stable/pollev.dmg')
      cutlassEvent(document.body, 'participate:cta', {
        context
      })
      break

    default:
      window.peBeforeInstallPromptEvent?.prompt()
      window.peBeforeInstallPromptEvent?.userChoice.then(choiceResult => {
        cutlassEvent(document.body, 'participate:cta', {
          context,
          outcome: choiceResult.outcome
        })
      })
      break
  }
}

export function isOkToShowInstallAppCTA () {
  // Dont show in mobile env
  if (appInfo.operatingSystem === 'android' || appInfo.operatingSystem === 'ios' || window.Capacitor?.isNative) {
    return false
  }

  // Dont show on not installable environments
  if (appInfo.operatingSystem !== 'mac') {
    if (!window.peBeforeInstallPromptEvent) {
      return false
    }
  }

  // Dont show if already installed
  if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
    return false
  }

  // Dont show in Electron environment
  if (appInfo.electron) {
    return false
  }

  return true
}
